import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, computed, toRefs, watch } from 'vue';
/** 常量 */
import { versionCoverTableHeader } from '../const/interactData.js';
export default {
  __name: 'viewAllDialog',
  props: {
    viewVisible: {
      type: Boolean,
      default: false
    },
    tableRow: {
      // 点击项所在行数据
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['changeViewVisible'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /** 组合式api */
    var props = __props;
    var emit = __emit;
    var _toRefs = toRefs(props),
      tableRow = _toRefs.tableRow;
    /** 计算属性 */
    var visible = computed(function () {
      return props.viewVisible;
    });

    /** 监听 */
    watch(function () {
      return props.tableRow;
    }, function (nval) {
      if (nval) tableData.value = nval.versionRate;
    });

    /** 初始化相关 */
    var tableData = ref([]);

    /** 事件相关 */
    /**
     * 关闭弹窗
     */
    var closedDialog = function closedDialog() {
      emit('changeViewVisible', false);
    };
    return function (_ctx, _cache) {
      var _component_t_table = _resolveComponent("t-table");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: visible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return visible.value = $event;
        }),
        header: _unref(tableRow).schoolName + '版本覆盖率',
        width: "40%",
        placement: "center",
        cancelBtn: null,
        confirmBtn: null,
        onClose: closedDialog
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_t_table, {
            rowKey: "version",
            columns: _unref(versionCoverTableHeader),
            data: tableData.value,
            height: "60vh",
            class: "table-box"
          }, {
            operate: _withCtx(function () {
              return [_createElementVNode("div", {
                class: "blue-text",
                onClick: _cache[0] || (_cache[0] = function () {
                  return _ctx.handleViewAll && _ctx.handleViewAll.apply(_ctx, arguments);
                })
              }, "查看全部")];
            }),
            empty: _withCtx(function () {
              return _toConsumableArray(_cache[2] || (_cache[2] = []));
            }),
            _: 1
          }, 8, ["columns", "data"])];
        }),
        _: 1
      }, 8, ["visible", "header"]);
    };
  }
};